import classnames from "classnames"
import TimePicker from "rc-time-picker"
import "rc-time-picker/assets/index.css"
import React from "react"
import {
  FULLSCREEN_LAYER_BASE,
  FULLSCREEN_LAYER_OVERLAY
} from "../../fullscreen/Fullscreen"
import FieldWrapper from "../form-utils/FieldWrapper"

export default function ({ className, ...rest }) {
  return (
    <FieldWrapper {...rest} className={classnames("TimePicker", className)}>
      <TimePicker
        showSecond={false}
        use12Hours
        inputReadOnly={false}
        clearIcon={<React.Fragment />}
        popupStyle={{
          zIndex: FULLSCREEN_LAYER_BASE + FULLSCREEN_LAYER_OVERLAY
        }}
        {...rest}
      />
    </FieldWrapper>
  )
}
